<template>
  <div class="enacted-bills-page">
    <div class="page-header">
      <h1>Enacted Bills</h1>
    </div>

    <DataTable 
      v-model:filters="filters" 
      :value="enactedBills" 
      paginator 
      :rows="10" 
      :rowsPerPageOptions="[5, 10, 20, 50]" 
      filterDisplay="row" 
      :globalFilterFields="['nos', 'title', 'short_title', 'remarks']" 
      class="p-datatable-sm"
    >
      <template #header>
        <div class="table-header">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" placeholder="Global Search" />
          </span>
        </div>
      </template>
      
      <Column field="nos" header="Republic Act No." sortable>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" @input="filterCallback()" placeholder="Search by RA No." />
        </template>
      </Column>
      
      <Column field="title" header="Title" sortable>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" @input="filterCallback()" placeholder="Search by title" />
        </template>
      </Column>
      
      <Column field="short_title" header="Short Title" sortable>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" @input="filterCallback()" placeholder="Search by short title" />
        </template>
      </Column>
      
      <Column field="remarks" header="Remarks" sortable>
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" @input="filterCallback()" placeholder="Search by remarks" />
        </template>
      </Column>
      
      <Column field="source" header="Source">
        <template #body="{ data }">
          <a v-if="data.source" :href="data.source" target="_blank" class="source-link">
            View Source
          </a>
          <span v-else>N/A</span>
        </template>
      </Column>
      
      <Column field="legislative_statuses" header="Legislative Status">
        <template #body="{ data }">
          
          <div v-if="getLatestStatus(data.legislative_statuses)" class="status-item">
            <span class="status-badge">{{ getLatestStatus(data.legislative_statuses).status }}</span>
            <span class="status-date">{{ formatDate(getLatestStatus(data.legislative_statuses).status_date) }}</span>
          </div>
          <span v-else class="no-status">No status available</span>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
export default {
  data() {
    return {
      enactedBills: [],
      filters: {
        global: { value: null, matchMode: 'contains' },
        nos: { value: null, matchMode: 'contains' },
        title: { value: null, matchMode: 'contains' },
        short_title: { value: null, matchMode: 'contains' },
        remarks: { value: null, matchMode: 'contains' }
      }
    }
  },
  methods: {
    async loadEnactedBills() {
      try {
        const response = await fetch('https//:lmp.dof.gov.ph/api/enacted-bills')
        this.enactedBills = await response.json()
      } catch (error) {
        console.error('Error loading enacted bills:', error)
        this.enactedBills = []
      }
    },
    formatDate(date) {
      if (!date) return 'N/A'
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    getLatestStatus(statuses) {
      if (!statuses || statuses.length === 0) return null
      return statuses.reduce((latest, current) => {
        const latestDate = new Date(latest.status_date || 0)
        const currentDate = new Date(current.status_date || 0)
        return currentDate > latestDate ? current : latest
      })
    }
  },
  mounted() {
    this.loadEnactedBills()
  }
}
</script>

<style scoped>
.enacted-bills-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #1e3a8a;
}

.page-header h1 {
  color: #1e3a8a;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}

.p-input-icon-left {
  position: relative;
}

.p-input-icon-left .pi {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
}

.p-input-icon-left input {
  padding-left: 2.5rem;
}

.source-link {
  color: #1e3a8a;
  text-decoration: none;
  font-weight: 500;
}

.source-link:hover {
  text-decoration: underline;
}

.status-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.status-badge {
  background: #e0e7ff;
  color: #3730a3;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  width: fit-content;
}

.status-date {
  font-size: 0.8rem;
  color: #6b7280;
}

.no-status {
  color: #9ca3af;
  font-style: italic;
}

@media (max-width: 768px) {
  .enacted-bills-page {
    padding: 1rem;
  }
}
</style>